import script from "./SearchDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./SearchDropdown.vue?vue&type=style&index=0&id=556732be&lang=postcss"

const __exports__ = script;

export default __exports__